import { Inject, Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoggingService } from '../services/logging/logging.service';
import { Store } from '@ngrx/store';
import * as fromStore from './store';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    /**
     *
     */
    constructor(
        private store: Store<fromStore.LoadingState>,
        private log: LoggingService
    ) {}

    public intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // Clone the request to add the new header
        // if (!this.authService.bearerToken) { return; }
        if (req.url.indexOf('/api/') >= 0) {
            this.log.verbose({ type: 'LoadingInterceptor' });

            this.store.dispatch(new fromStore.SetLoading(true));
        }

        // Pass the cloned request instead of the original request to the next handle
        // return next.handle(clonedRequest)
        return next.handle(req).pipe(
            tap(() => {
                this.store.dispatch(new fromStore.SetLoading(false));
            })
        );
    }
}
